export default {
    lang: {
        name: 'Rating changes'
    }
}